// databaseConstants.ts
export const ClientDatabase = {
    version: 1,
    name: "PtnDatabase",
};
export const stores = [
    {
        name: "sites",
        options: { keyPath: "ID" },
        indexes: [
        //{ name: "siteName", keyPath: "Name", options: { unique: true } },
        ],
        endpointUrl: "Sites/sites",
    },
    {
        name: "config",
        options: { keyPath: "ID" },
        indexes: [
        //{ name: "configName", keyPath: "ConfigName", options: { unique: true } },
        ],
        endpointUrl: "Configuration/config",
    },
    // Add more stores as needed
    // trials 
    {
        name: "trials",
        options: { keyPath: "ID" },
        indexes: [
            { name: "trialName", keyPath: "Name", options: { unique: false } },
        ],
        endpointUrl: "Trials/trials",
    },
    //varieties
    {
        name: "varieties",
        options: { keyPath: "ID" },
        indexes: [
            { name: "varietyName", keyPath: "Name", options: { unique: false } },
        ],
        endpointUrl: "Varieties/varieties",
    },
    //Species
    {
        name: "species",
        options: { keyPath: "ID" },
        indexes: [
            { name: "Name", keyPath: "Name", options: { unique: false } },
        ],
        endpointUrl: "Species/species",
    },
    //AdministrativeRegions
    {
        name: "administrativeregions",
        options: { keyPath: "ID" },
        indexes: [
            { name: "Name", keyPath: "Name", options: { unique: false } },
        ],
        endpointUrl: "AdministrativeRegions/administrativeregions",
    },
    //trialresults 
    {
        name: "trialresults",
        options: { keyPath: "ID" },
        indexes: [
            { name: "trialresultTrialId", keyPath: "TrialId", options: { unique: false } },
        ],
        endpointUrl: "TrialResults/trialresults",
    },
    //trialresults 
    {
        name: "trialSummaryTables",
        options: { keyPath: "ID" },
        indexes: [
            { name: "summaryTrialID", keyPath: "TrialID", options: { unique: false } },
        ],
        endpointUrl: "TrialResults/trialresulttables",
    },
];
